import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=69dae3a2&lang=pug&"
import script from "./verification.vue?vue&type=script&lang=js&"
export * from "./verification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69dae3a2')) {
      api.createRecord('69dae3a2', component.options)
    } else {
      api.reload('69dae3a2', component.options)
    }
    module.hot.accept("./verification.vue?vue&type=template&id=69dae3a2&lang=pug&", function () {
      api.rerender('69dae3a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/verification/verification.vue"
export default component.exports